'use client';

import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/Select';
import { useChatMode } from '@/contexts/ChatModeContext';
import ChatGpt from '../Icons/ChatGptIcon';
import GrokIcon from '../Icons/GrokIcon';
import Image from 'next/image';

const AgentVersion = () => {
  const { agent, changeAgent } = useChatMode();

  const agents = [
    {
      value: 'gpt-5',
      label: 'GPT-5',
      icon: <ChatGpt size={20} />,
    },
    {
      value: 'gemini-2.5',
      label: 'Gemini-2.5',
      icon: (
        <Image
          src="https://www.gstatic.com/lamda/images/gemini_sparkle_aurora_33f86dc0c0257da337c63.svg"
          alt="gemini"
          width={20}
          height={20}
        />
      ),
    },
    { value: 'grok-4', label: 'Grok-4', icon: <GrokIcon size={20} /> },
    {
      value: 'claude',
      label: 'Claude',
      icon: <Image src="/image/claude.svg" alt="claude" width={20} height={20} />,
    },
  ];

  // useEffect(() => {
  //   changeAgent('gpt-5');
  // }, []);

  return (
    <Select onValueChange={changeAgent} value={agent}>
      <SelectTrigger className="w-[150px] focus:ring-0 focus:ring-ring focus:ring-offset-0 rounded-full border border-[#2a2a2a] px-3 h-[32px] cursor-pointer flex items-center justify-between">
        <SelectValue />
      </SelectTrigger>
      <SelectContent className="bg-bg-main">
        {agents.map((item) => (
          <SelectItem key={item.value} value={item.value} className="bg-bg-main py-1">
            <div className="flex items-center gap-2">
              {item.icon}
              {item.label}
            </div>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};

export default AgentVersion;
